import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import * as powerbi from 'powerbi-client';

@Component({
  selector: 'app-power-bi-report',
  templateUrl: './power-bi-report.component.html',
  styleUrls: ['./power-bi-report.component.css']
})
export class PowerBiReportComponent implements OnInit {
 @ViewChild('reportContainer') reportContainer!: ElementRef;

  @Input() reportId!: string;
  @Input() embedUrl!: string;
  @Input() accessToken!: string;

  ngOnInit(): void {
    const embedConfig: powerbi.IEmbedConfiguration = {
      type: 'report',
      id: this.reportId,
      embedUrl: this.embedUrl,
      accessToken: this.accessToken,
      tokenType: powerbi.models.TokenType.Embed,
      viewMode: powerbi.models.ViewMode.View,
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        layoutType: powerbi.models.LayoutType.Custom,
        customLayout:{
          displayOption: powerbi.models.DisplayOption.FitToWidth,
        },
        panes: {
          filters: {
              visible: false
          },
          pageNavigation: {
              visible: false
          },
        },
      }
    };

    const powerBiService = new powerbi.service.Service(powerbi.factories.hpmFactory, powerbi.factories.wpmpFactory, powerbi.factories.routerFactory);
    powerBiService.embed(this.reportContainer.nativeElement, embedConfig);
  }
}